/* Cart + scroll reveal.
   The cart is localStorage only — a stand-in so the buying flow is testable
   before Shopify takes over checkout. */
(function () {
  var KEY = 'tro_cart';
  var read = function () { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } };
  var write = function (c) { try { localStorage.setItem(KEY, JSON.stringify(c)); } catch (e) {} paint(); };
  var money = function (n) { return '$' + Number(n).toLocaleString('en-US'); };

  var tnode, ttimer;
  function toast(msg) {
    if (!tnode) {
      tnode = document.createElement('div');
      tnode.className = 'toast';
      tnode.setAttribute('role', 'status');
      document.body.appendChild(tnode);
    }
    tnode.innerHTML = '<svg viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5"/></svg><span></span>';
    tnode.querySelector('span').textContent = msg;
    requestAnimationFrame(function () { tnode.classList.add('show'); });
    clearTimeout(ttimer);
    ttimer = setTimeout(function () { tnode.classList.remove('show'); }, 2600);
  }

  function count() { return read().reduce(function (n, i) { return n + i.qty; }, 0); }

  function paint() {
    var n = count();
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n; el.style.display = n ? 'flex' : 'none';
    });
    var body = document.getElementById('cartBody');
    if (!body) return;
    var cart = read();
    if (!cart.length) {
      body.innerHTML = '<p class="lede">Your cart is empty.</p>' +
        '<a class="btn btn--green" href="shop.html" style="margin-top:22px">Shop materials</a>';
      return;
    }
    var rows = cart.map(function (i, idx) {
      var img = i.img ? '<img src="img/' + i.img + '" alt="">' : '<img alt="">';
      return '<div class="cartline">' + img +
        '<div class="cartline__b"><div class="cartline__t">' + i.name + '</div>' +
        '<div class="cartline__m">' + money(i.price) + ' / ' + (i.unit || 'kg') + '</div></div>' +
        '<div class="cartq"><button data-dec="' + idx + '" aria-label="Less">&minus;</button>' +
        '<span>' + i.qty + '</span>' +
        '<button data-inc="' + idx + '" aria-label="More">+</button></div>' +
        '<div class="cartline__sub">' + money(i.price * i.qty) + '</div>' +
        '<button class="cartline__x" data-rm="' + idx + '" aria-label="Remove">&times;</button></div>';
    }).join('');
    var total = cart.reduce(function (s, i) { return s + i.price * i.qty; }, 0);
    // tally per unit so a kilo line and an ounce line never add up to one number
    var per = {};
    cart.forEach(function (i) { var u = i.unit || 'kg'; per[u] = (per[u] || 0) + i.qty; });
    var amount = Object.keys(per).map(function (u) { return per[u] + ' ' + u; }).join(' + ');
    body.innerHTML = rows +
      '<div class="cartsum"><div><div class="cartsum__t">' + amount + ' &middot; ' +
      cart.length + (cart.length === 1 ? ' line' : ' lines') + '</div>' +
      '<div class="cartsum__v">' + money(total) + '</div></div>' +
      '<div class="cartsum__a"><button class="btn btn--ghost" data-clear type="button">Clear</button>' +
      '<button class="btn btn--green" type="button" data-cartquote>Send for final quote</button></div></div>' +
      '<p class="quote__note" style="text-align:left;margin-top:16px">Freight and lead time are ' +
      'confirmed on the quote.</p>';
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-add]');
    if (add) {
      var cart = read(), name = add.dataset.name, price = +add.dataset.price;
      // the PDP button carries data-qty and reads the stepper; grid buttons add one
      var box = document.getElementById('qty');
      var n = (add.hasAttribute('data-qty') && box) ? Math.max(1, parseInt(box.value, 10) || 1) : 1;
      var chip = document.querySelector('[data-chip][aria-pressed="true"]');
      var label = chip ? name + ' (' + chip.textContent.trim() + ')' : name;
      var hit = cart.filter(function (i) { return i.name === label; })[0];
      if (hit) hit.qty += n; else cart.push({ name: label, price: price, qty: n, unit: add.dataset.unit || 'kg', img: add.dataset.img || '' });
      write(cart);
      toast(label + ' \u00d7 ' + n + ' added');
      add.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.2)' }, { transform: 'scale(1)' }], 260);
      return;
    }
    var step = e.target.closest('[data-q]');
    if (step) {
      var qb = document.getElementById('qty');
      if (qb) qb.value = Math.max(1, (parseInt(qb.value, 10) || 1) + (step.dataset.q === '+' ? 1 : -1));
      return;
    }
    var chipBtn = e.target.closest('[data-chip]');
    if (chipBtn) {
      document.querySelectorAll('[data-chip]').forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
      chipBtn.setAttribute('aria-pressed', 'true');
      return;
    }
    var inc = e.target.closest('[data-inc]'), dec = e.target.closest('[data-dec]');
    if (inc || dec) {
      var c = read(), i = +(inc || dec).dataset[inc ? 'inc' : 'dec'];
      if (inc) c[i].qty++; else if (--c[i].qty < 1) c.splice(i, 1);
      write(c); return;
    }
    var rm = e.target.closest('[data-rm]');
    if (rm) { var cc = read(); cc.splice(+rm.dataset.rm, 1); write(cc); return; }
    if (e.target.closest('[data-clear]')) write([]);
  });

  var HS_PORTAL = '247568348', HS_FORM = '70f7e376-71b2-4915-9520-59d17f1229b9';
  document.addEventListener('submit', function (e) {
    var f = e.target; if (f.id !== 'quoteForm') return;
    e.preventDefault();
    var g = function (n) { var el = f.elements[n]; return el ? el.value.trim() : ''; };
    var cart = read();
    var basket = cart.length
      ? '\n\nCart:\n' + cart.map(function (i) { return '- ' + i.name + ' x' + i.qty + ' ' + (i.unit || 'kg'); }).join('\n')
      : '';
    var body = ['Name: ' + g('name'), 'Company: ' + g('company'), 'Email: ' + g('email'),
      'Phone: ' + g('phone'), 'Interest: ' + g('interest'), 'Volume: ' + g('volume'),
      '', g('message') + basket].join('\n');
    var mailto = function () {
      window.location.href = 'mailto:sales@therawoutlet.com?subject=' +
        encodeURIComponent('Quote request — ' + (g('company') || g('name'))) +
        '&body=' + encodeURIComponent(body);
    };

    // send straight to HubSpot ("Website – Quote Request" form); email is only the fallback
    var parts = g('name').split(/\s+/), first = parts.shift() || '', last = parts.join(' ');
    var note = ['What do you need: ' + g('interest'), 'Estimated volume: ' + (g('volume') || '-'),
      '', g('message') || '(no message)'].join('\n') + basket;
    var btn = f.querySelector('[type=submit]'), label = btn.innerHTML;
    btn.disabled = true; btn.textContent = 'Sending...';
    fetch('https://api.hsforms.com/submissions/v3/integration/submit/' + HS_PORTAL + '/' + HS_FORM, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        fields: [
          { name: 'firstname', value: first }, { name: 'lastname', value: last },
          { name: 'email', value: g('email') }, { name: 'phone', value: g('phone') },
          { name: 'company', value: g('company') }, { name: 'message', value: note }
        ],
        context: { pageUri: location.href, pageName: document.title,
          hutk: (document.cookie.match(/hubspotutk=([^;]+)/) || [])[1] }
      })
    }).then(function (r) {
      if (!r.ok) throw new Error('HubSpot ' + r.status);
      f.querySelector('.qform__body').innerHTML =
        '<div class="qform__done"><b>Thanks, ' + (first || 'we got it') + '!</b>' +
        '<p>Your request is in. We usually reply the same day.</p></div>';
    }).catch(function () {
      btn.disabled = false; btn.innerHTML = label;
      mailto();
    });
  });

  // give every section heading, panel, form and grid the same gentle fade-up,
  // except the hero areas at the top of each page (those should be there on load)
  document.querySelectorAll(
    '.sec__head, .sec .eyebrow, .sec .h-lg, .sec__intro, .quote__left, .qform, .panel, .ctcard,' +
    ' .bento, .steps, .split2 > *, .split > *, .feats, .counters, .mgrid, .faqgrp, .sec__more'
  ).forEach(function (el) {
    if (!el.closest('.hero, .phero, .cthero, .abhero, .head, .rv')) el.classList.add('rv');
  });

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.rv').forEach(function (el, n) {
      el.style.transitionDelay = (n % 4) * 55 + 'ms'; io.observe(el);
    });
  } else {
    document.querySelectorAll('.rv').forEach(function (el) { el.classList.add('in'); });
  }
  // ----- product page extras -----
  var qtyBox = document.getElementById('qty');
  if (qtyBox) {
    var runEl = document.querySelector('[data-running]');
    var noteEl = document.querySelector('[data-running-note]');
    var tiers = [].slice.call(document.querySelectorAll('.tier'));

    function sync() {
      var n = Math.max(1, parseInt(qtyBox.value, 10) || 1);
      if (qtyBox.value != n) qtyBox.value = n;
      if (runEl) {
        var unit = +runEl.dataset.unit;
        runEl.textContent = '$' + (unit * n).toLocaleString('en-US');
      }
      if (noteEl) noteEl.textContent = 'for ' + n + ' ' + (noteEl.dataset.u || 'kg');
      // move the highlight onto the band the quantity now falls in
      if (tiers.length === 3) {
        var band = n < 5 ? 0 : (n < 10 ? 1 : 2);
        tiers.forEach(function (t, i) { t.classList.toggle('tier--on', i === band); });
      }
    }
    qtyBox.addEventListener('input', sync);
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-q]')) setTimeout(sync, 0);
    });
    sync();
  }

  var sticky = document.querySelector('[data-stickybuy]');
  var anchor = document.querySelector('.pdp__buy');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      // show the bar only once the real buy row has scrolled out of view
      sticky.classList.toggle('show', !es[0].isIntersecting && es[0].boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(anchor);
  }

  // ----- shop filter + sort -----
  var grid = document.querySelector('[data-grid]');
  if (grid) {
    var cards = [].slice.call(grid.querySelectorAll('.prod'));
    var order = cards.slice();
    var countEl = document.querySelector('[data-fcount]');
    var emptyEl = document.querySelector('[data-empty]');
    var host = grid.firstElementChild || grid;

    function apply() {
      var on = document.querySelector('.fchip[aria-pressed="true"]');
      var f = on ? on.dataset.f : 'all';
      var mode = (document.querySelector('[data-sort]') || {}).value || 'feat';
      var list = order.slice();
      if (mode === 'low')  list.sort(function (a, b) { return a.dataset.price - b.dataset.price; });
      if (mode === 'high') list.sort(function (a, b) { return b.dataset.price - a.dataset.price; });
      if (mode === 'az')   list.sort(function (a, b) { return a.dataset.name < b.dataset.name ? -1 : 1; });
      var shown = 0;
      list.forEach(function (c) {
        var ok = (f === 'all' || c.dataset.cat === f);
        c.hidden = !ok; if (ok) shown++;
        host.appendChild(c);
      });
      if (countEl) countEl.textContent = shown + (shown === 1 ? ' product' : ' products');
      if (emptyEl) emptyEl.hidden = shown > 0;
    }
    document.addEventListener('click', function (e) {
      var c = e.target.closest('.fchip'); if (!c) return;
      document.querySelectorAll('.fchip').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
      c.setAttribute('aria-pressed', 'true'); apply();
    });
    var sortEl = document.querySelector('[data-sort]');
    if (sortEl) sortEl.addEventListener('change', apply);
  }

  // ----- 21+ gate -----
  var gate = document.querySelector('[data-gate]');
  if (gate) {
    var pass = function () {
      try { localStorage.setItem('tro_age', 'ok'); } catch (e) {}
      document.documentElement.classList.remove('gated');
    };
    var deny = function () {
      gate.querySelector('.agegate__card').className = 'agegate__card agegate__deny';
      gate.querySelector('.agegate__card').innerHTML =
        '<span class="agegate__k"><i aria-hidden="true"></i>Access denied</span>' +
        '<h2>You must be 21 or older.</h2>' +
        '<p>We cannot let you browse this site. Thanks for stopping by.</p>' +
        '<p class="agegate__fine">If you entered your age by mistake, reload the page to try again.</p>';
    };
    gate.addEventListener('click', function (e) {
      if (e.target.closest('[data-gate-yes]')) pass();
      if (e.target.closest('[data-gate-no]')) deny();
    });
    // keep focus inside the dialog while it is up
    if (document.documentElement.classList.contains('gated')) {
      var y = gate.querySelector('[data-gate-yes]');
      if (y) y.focus();
      document.addEventListener('keydown', function (e) {
        if (!document.documentElement.classList.contains('gated')) return;
        if (e.key === 'Tab') {
          var f = gate.querySelectorAll('button');
          if (!f.length) return;
          var first = f[0], last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      });
    }
  }

  // ----- FAQ: search, highlight, scroll spy -----
  var fq = document.querySelector('[data-faqsearch]');
  if (fq) {
    var groups = [].slice.call(document.querySelectorAll('[data-grp]'));
    var items = [].slice.call(document.querySelectorAll('[data-faq]'));
    var emptyF = document.querySelector('[data-faqempty]');
    var nOut = document.querySelector('[data-faqn]');
    var wrapS = document.querySelector('[data-bigsearch]');

    // keep the original text so repeated searches re-highlight from clean copy
    items.forEach(function (d) {
      d.dataset.q = d.querySelector('.qa__t').textContent;
      d.dataset.a = d.querySelector('.qa__a').textContent;
    });

    function hEsc(t) {
      return t.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
    function mark(el, text, term) {
      if (!term) { el.textContent = text; return; }
      var low = text.toLowerCase(), t = term.toLowerCase(), out = '', i = 0, pos;
      while ((pos = low.indexOf(t, i)) > -1) {
        out += hEsc(text.slice(i, pos)) + '<mark>' + hEsc(text.slice(pos, pos + t.length)) + '</mark>';
        i = pos + t.length;
      }
      el.innerHTML = out + hEsc(text.slice(i));
    }

    function run() {
      var t = fq.value.trim();
      var low = t.toLowerCase(), hits = 0;
      items.forEach(function (d) {
        var ok = !t || (d.dataset.q + ' ' + d.dataset.a).toLowerCase().indexOf(low) > -1;
        d.hidden = !ok;
        if (ok) hits++;
        mark(d.querySelector('.qa__t'), d.dataset.q, t);
        mark(d.querySelector('.qa__a'), d.dataset.a, t);
        d.open = !!t && ok;
      });
      groups.forEach(function (g) {
        g.hidden = !g.querySelector('[data-faq]:not([hidden])');
      });
      if (emptyF) emptyF.hidden = hits > 0;
      if (wrapS) wrapS.classList.toggle('searching', !!t);
      if (nOut) nOut.textContent = hits + (hits === 1 ? ' match' : ' matches');
    }
    fq.addEventListener('input', run);
    fq.addEventListener('keydown', function (e) { if (e.key === 'Escape') { fq.value = ''; run(); fq.blur(); } });
    document.addEventListener('keydown', function (e) {
      if (e.key === '/' && document.activeElement !== fq &&
          !/^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement.tagName)) {
        e.preventDefault(); fq.focus();
      }
    });

    // scroll spy: mark the section currently under the header
    var spy = [].slice.call(document.querySelectorAll('[data-spy]'));
    if (spy.length && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (x) {
          if (!x.isIntersecting) return;
          spy.forEach(function (a) { a.classList.toggle('on', a.dataset.spy === x.target.id); });
        });
      }, { rootMargin: '-120px 0px -70% 0px' }).observe ?
        groups.forEach(function (g) {
          new IntersectionObserver(function (es) {
            if (!es[0].isIntersecting) return;
            spy.forEach(function (a) { a.classList.toggle('on', a.dataset.spy === g.id); });
          }, { rootMargin: '-120px 0px -70% 0px' }).observe(g);
        }) : null;
    }
  }

  // ----- count-up stats -----
  var counters = [].slice.call(document.querySelectorAll('[data-count]'));
  if (counters.length && 'IntersectionObserver' in window) {
    var cio = new IntersectionObserver(function (es) {
      es.forEach(function (x) {
        if (!x.isIntersecting) return;
        cio.unobserve(x.target);
        var el = x.target, end = +el.dataset.count, sfx = el.dataset.suffix || '';
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          el.textContent = end + sfx; return;
        }
        var t0 = performance.now(), dur = 1100;
        (function tick(now) {
          var k = Math.min(1, (now - t0) / dur);
          k = 1 - Math.pow(1 - k, 3);
          el.textContent = Math.round(end * k) + sfx;
          if (k < 1) requestAnimationFrame(tick);
        })(t0);
      });
    }, { rootMargin: '0px 0px -12% 0px' });
    counters.forEach(function (c) { cio.observe(c); });
  }

  paint();

  // ----- material index search -----
  var mq = document.querySelector('[data-matsearch]');
  if (mq) {
    var cards = [].slice.call(document.querySelectorAll('.mcard[data-cardname]'));
    var chips = [].slice.call(document.querySelectorAll('.chip[data-mat]'));
    var cnt = document.querySelector('[data-matcount]');
    var emptyM = document.querySelector('[data-matempty]');
    var totalMats = chips.length;
    mq.addEventListener('input', function () {
      var t = mq.value.trim().toLowerCase(), shown = 0;
      chips.forEach(function (c) {
        var ok = !t || c.dataset.mat.indexOf(t) > -1;
        c.hidden = !ok; if (ok) shown++;
      });
      cards.forEach(function (card) {
        // keep a card whose own name matches, even if no chip inside it does
        var nameHit = t && card.dataset.cardname.indexOf(t) > -1;
        if (nameHit) {
          card.hidden = false;
          [].slice.call(card.querySelectorAll('.chip')).forEach(function (c) { c.hidden = false; });
          return;
        }
        card.hidden = !card.querySelector('.chip:not([hidden])');
      });
      if (nameHitTotal()) shown = nameHitTotal();
      function nameHitTotal() {
        return [].slice.call(document.querySelectorAll('.chip[data-mat]:not([hidden])')).length;
      }
      if (cnt) cnt.textContent = (t ? shown : totalMats) + ' material' + ((t ? shown : totalMats) === 1 ? '' : 's');
      if (emptyM) emptyM.hidden = shown > 0;
    });
  }

})();

/* Cart → "Send for final quote": pop-up contact form that sends the order to HubSpot.
   Lines come from the on-page cart (Shopify: [data-qline] rows) or the local cart. */
(function () {
  var HS = 'https://api.hsforms.com/submissions/v3/integration/submit/247568348/70f7e376-71b2-4915-9520-59d17f1229b9';
  var money = function (n) { return '$' + Number(n).toLocaleString('en-US', { maximumFractionDigits: 2 }); };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

  function lines() {
    var rows = [].slice.call(document.querySelectorAll('[data-qline]'));
    if (rows.length) return rows.map(function (r) {
      return { name: r.dataset.name, qty: +r.dataset.qty, unit: r.dataset.unit || 'kg', price: +r.dataset.price };
    });
    try { return (JSON.parse(localStorage.getItem('tro_cart')) || []).map(function (i) {
      return { name: i.name, qty: i.qty, unit: i.unit || 'kg', price: i.price };
    }); } catch (e) { return []; }
  }

  function open() {
    var items = lines(); if (!items.length) return;
    var total = items.reduce(function (s, i) { return s + i.price * i.qty; }, 0);
    var list = items.map(function (i) {
      return '<li><span>' + esc(i.name) + ' <em>&times; ' + i.qty + ' ' + esc(i.unit) + '</em></span><b>' + money(i.price * i.qty) + '</b></li>';
    }).join('');
    var m = document.createElement('div');
    m.className = 'cq'; m.setAttribute('role', 'dialog'); m.setAttribute('aria-modal', 'true');
    m.innerHTML =
      '<div class="cq__card"><button class="cq__x" type="button" data-cq-close aria-label="Close">&times;</button>' +
      '<p class="eyebrow">Final quote</p><h2 class="cq__h">Where should we send your quote?</h2>' +
      '<p class="cq__sub">We confirm price, freight and lead time, usually the same day.</p>' +
      '<div class="cq__sum"><ul>' + list + '</ul><div class="cq__tot"><span>Estimated total</span><b>' + money(total) + '</b></div></div>' +
      '<form class="cq__f" novalidate data-hs-do-not-collect="true">' +
        '<div class="two"><div class="field"><label>Your name</label><input name="name" autocomplete="name" required></div>' +
        '<div class="field"><label>Company <em>optional</em></label><input name="company" autocomplete="organization"></div></div>' +
        '<div class="two"><div class="field"><label>Email</label><input name="email" type="email" autocomplete="email" required></div>' +
        '<div class="field"><label>Phone</label><input name="phone" type="tel" autocomplete="tel" required></div></div>' +
        '<div class="field"><label>Ship-to ZIP code <em>for freight</em></label><input name="zip" autocomplete="postal-code" inputmode="numeric"></div>' +
        '<div class="field"><label>Notes <em>optional</em></label><textarea name="notes" rows="2" placeholder="Deadline, packaging, a competitor quote to match..."></textarea></div>' +
        '<p class="cq__err" hidden>Please fill in your name, email and phone.</p>' +
        '<button class="btn btn--green cq__go" type="submit">Send my quote request</button>' +
      '</form></div>';
    document.body.appendChild(m);
    document.documentElement.classList.add('cq-open');
    setTimeout(function () { m.classList.add('show'); var n = m.querySelector('[name=name]'); if (n) n.focus(); }, 10);

    m.addEventListener('click', function (e) { if (e.target === m || e.target.closest('[data-cq-close]')) close(m); });
    document.addEventListener('keydown', function k(e) { if (e.key === 'Escape') { close(m); document.removeEventListener('keydown', k); } });

    m.querySelector('form').addEventListener('submit', function (e) {
      e.preventDefault();
      var f = e.target, g = function (n) { return (f.elements[n].value || '').trim(); };
      if (!g('name') || !/.+@.+\..+/.test(g('email')) || !g('phone')) { f.querySelector('.cq__err').hidden = false; return; }
      var parts = g('name').split(/\s+/), first = parts.shift() || '', last = parts.join(' ');
      var order = items.map(function (i) {
        return '- ' + i.name + ' x ' + i.qty + ' ' + i.unit + ' @ ' + money(i.price) + '/' + i.unit + ' = ' + money(i.price * i.qty);
      }).join('\n');
      var msg = 'QUOTE REQUEST FROM CART\n\n' + order + '\n\nEstimated total: ' + money(total) +
        '\nShip-to ZIP: ' + (g('zip') || '-') + '\n\nNotes: ' + (g('notes') || '-');
      var btn = f.querySelector('.cq__go'); btn.disabled = true; btn.textContent = 'Sending...';
      fetch(HS, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({
        fields: [{ name: 'firstname', value: first }, { name: 'lastname', value: last },
          { name: 'email', value: g('email') }, { name: 'phone', value: g('phone') },
          { name: 'company', value: g('company') }, { name: 'message', value: msg }],
        context: { pageUri: location.href, pageName: 'Cart: final quote',
          hutk: (document.cookie.match(/hubspotutk=([^;]+)/) || [])[1] } }) })
      .then(function (r) {
        if (!r.ok) throw new Error();
        m.querySelector('.cq__card').innerHTML =
          '<div class="cq__done"><span class="cq__ok" aria-hidden="true">&#10003;</span><h2 class="cq__h">Request sent, ' + esc(first) + '!</h2>' +
          '<p class="cq__sub">We have your order and contact details. Expect your final quote with freight and lead time, usually the same day.</p>' +
          '<button class="btn btn--ink" type="button" data-cq-close>Done</button></div>';
      })
      .catch(function () {
        btn.disabled = false; btn.textContent = 'Send my quote request';
        location.href = 'mailto:sales@therawoutlet.com?subject=' + encodeURIComponent('Final quote request - ' + (g('company') || g('name'))) +
          '&body=' + encodeURIComponent('Name: ' + g('name') + '\nCompany: ' + g('company') + '\nEmail: ' + g('email') + '\nPhone: ' + g('phone') + '\n\n' + msg);
      });
    });
  }
  function close(m) { m.classList.remove('show'); document.documentElement.classList.remove('cq-open'); setTimeout(function () { m.remove(); }, 200); }

  document.addEventListener('click', function (e) { if (e.target.closest('[data-cartquote]')) { e.preventDefault(); open(); } });
})();

